import { Box } from "@novel/shared/components/Box";
import { IconWrapper } from "@novel/shared/components/PolarisIconWrapper";
import { UnstyledLink, CallbackAction, LinkAction, Button } from "@shopify/polaris";
import { MobileChevronMajor } from "@shopify/polaris-icons";
import * as React from "react";
export interface Props {
  readonly breadcrumbs: (CallbackAction | LinkAction)[] | undefined;
}
export default function CustomBreadCrumbs({
  breadcrumbs
}: Props): JSX.Element | null {
  return !breadcrumbs ? null : <React.Fragment>
            <div className="Breadcrumbs">
                {breadcrumbs.map(breadcrumb => "url" in breadcrumb ? <Box key={breadcrumb.url} alignItems="center" className="Breadcrumb">
                            <IconWrapper className="Breadcrumb-icon" icon={MobileChevronMajor} />
                            <UnstyledLink to={breadcrumb.url}>{breadcrumb.content}</UnstyledLink>
                        </Box> : <Box key={breadcrumb.id || breadcrumb.content} alignItems="center" className="Breadcrumb">
                            <IconWrapper className="Breadcrumb-icon" icon={MobileChevronMajor} />
                            <Button onClick={breadcrumb.onAction} plain monochrome removeUnderline>
                                {breadcrumb.content}
                            </Button>
                        </Box>)}
            </div>
            <style global jsx>{`
                .Breadcrumbs {
                    position: relative;
                    display: flex;
                    align-items: baseline;
                    margin: -4px;
                }

                .Breadcrumb {
                    position: relative;
                    padding: 8px 8px 8px 2px;
                    color: #637381;
                    text-decoration: none;
                    cursor: pointer;
                    transition: color 0.15s ease-in-out;
                }

                .Breadcrumb * {
                    cursor: pointer !important;
                }

                .Breadcrumb:hover,
                .Breadcrumb:focus {
                    outline: none;
                    text-decoration: none;
                    color: #212b36;
                }

                .Breadcrumb-icon {
                    height: 12px;
                    width: 12px;
                    margin-right: 5px;
                }
            `}</style>
        </React.Fragment>;
}